import React, {useEffect, useRef, useState} from 'react'
import Header from '../general/Header';
import SubHeader from '../general/SubHeader';
import Copyright from '../general/Copyright';
import '../css/components/Contact.css';
import emailjs from '@emailjs/browser';
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';


const Contact = () => {
  const [response, setResponse] = useState(null);
const [loading, setLoading] = useState(false);
const [dMobile, setDMobile] = useState('');

    useEffect(() => {
        const fetchMobile = async () => {
            try {
                const response = await fetch(`https://api.kcmstore.in/store/admin-info`);
                if (response.ok) {
                    const data = await response.json();
                        setDMobile(data[0]['phone']);
                } else {
                    console.error('Failed to fetch products');
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchMobile();
    }, []);


    const form = useRef();

    const sendEmail = (e) => {
        setLoading(true);
      e.preventDefault();
  
      emailjs
        .sendForm('service_kcmstore', 'template_contact', form.current, {
          publicKey: 'bU25sqIPXDYEBoiz4',
        })
        .then(
          () => {
            setLoading(false);
            console.log('Form Submitted!');
            setResponse('Your Form has been Submitted Successfully!');
            setTimeout(() => {
                setResponse('');
              }, 3000);
              form.current.reset();
          },
          (error) => {
            setLoading(false);
            console.log('FAILED...', error.text);
          },
        );
    };

    return (
        <>
            <Header />

            <SubHeader message="Contact Us" />


{/* Values section */}
<section className='bg-light py-4'>
  <div className='container'>

<div className='row'>

  <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-location-crosshairs medical-icon my-3 me-3"></i>
    <div>
    <p className='fs-5 fw-bold mb-0'>Office Address</p>
  <p className='medical-banner-heading'>Khatiyan No- 1166/1165, Mouja-Goilundi, Berhampur, Ganjam, Odisha, 760004</p></div>
  </div>

  <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-headset medical-icon my-3 me-3"></i>
    <div>
  <p className='fs-5 fw-bold mb-0'>Give A Call</p>
  <p className='medical-banner-heading'>+91 9692049594<br />+91 {dMobile || '97762 44971'}</p>    </div>
  </div>

  <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-paper-plane medical-icon my-3 me-3"></i>
    <div>
  <p className='fs-5 fw-bold mb-0'>Send Us Mail</p>
  <p className='medical-banner-heading'>newkcm.online@gmail.com</p></div>
  </div>


</div>
{/* row ends */}

  </div>
</section>
{/* Values section ends */}


<section className='my-5'>
    <div className='container'>

    <p className='sec-heading my-0'>Get In Touch</p>
    <p className='fw-semibold text-muted'>Fill the form below for any Enquiry. Our team will revert you soon.</p>

<div className='row'>

<div className='col-lg-6 col-12 my-3'>
<form class="row g-3" ref={form} onSubmit={sendEmail}>

    <div class="col-12 contact-label-area my-3">
    <label for="inputName" class="contact-label">Your Name</label>
    <input type="text" class="contact-control" name='user_name' id="inputName" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputPhone" class="contact-label">Mobile Number</label>
    <input type="tel" class="contact-control" name='user_mobile' id="inputPhone" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputEmail4" class="contact-label">Email</label>
    <input type="email" class="contact-control" name='user_email' id="inputEmail4" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputDescription" class="contact-label">Description</label>
    <textarea type="text" class="contact-control" name='message' id="inputDescription" style={{height: '10em'}}></textarea>
  </div>


  <div class="col-12 text-end">
    <button type="submit" class="login-btn2">Submit</button>
  </div>
</form>
</div>


<div className='col-lg-6 col-12 my-3'>
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2441.576139424195!2d84.80510985390553!3d19.307349088902175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d5079a95d11ad%3A0x2cf3c2e566c28329!2sGoilundi%2Cshanti%20Nagar!5e0!3m2!1sen!2sin!4v1741261012172!5m2!1sen!2sin"
className='w-100 h-100' style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

</div>
{/* row ends */}


    </div>
</section>

            <Copyright />

            {response && <ResponseMsg message={response} />}
            {loading && <Loading setLoading={setLoading} />}

        </>
    )
}

export default Contact
